<template>
	<div>
		<meta
			name="viewport"
			content="width=device-width, initial-scale=1.0, maximum-scale=1.0, 
     user-scalable=0"
		/>
		<qrcode-stream
			:track="selected.value"
			:torch="torchActive"
			@init="logErrors"
			@decode="onDecode"
			:camera="camera"
			class="qrReader"
			:key="qrReaderKey"
		>
			<!-- 상단 메뉴 -->
			<v-layout :class="$vuetify.breakpoint.xs ? 'qrHeadxs' : 'qrHead'">
				<v-flex class="qrTitle">상담 QR Reader</v-flex>
				<v-spacer />
			</v-layout>
			<!-- qr 인증박스 -->
			<v-layout :class="$vuetify.breakpoint.xs ? 'qrMiddlexs' : 'qrMiddle'" align-center justify-center>
				<div :class="nowWidth"></div>
			</v-layout>
			<!-- 촬영 버튼 -->
			<v-btn color="primary2" style="position: fixed; bottom: 0px;" dark @click="switchCamera" block height="50px">
				<span style="font-size: 20px;"> 카메라 전환({{ camera === 'front' ? '앞' : camera === 'auto' ? '자동' : '뒤' }})</span></v-btn
			>
		</qrcode-stream>
		<sweetAlert :dialog="sweetInfo" @close_active="sweetInfo.title === '오류발생' ? windowClose() : ''" />
	</div>
</template>

<script>
import { sweetAlert } from '@/components'
export default {
	components: {
		sweetAlert,
	},
	data() {
		const options = [
			{ text: 'nothing (default)', value: undefined },
			{ text: 'outline', value: this.paintOutline },
			{ text: 'centered text', value: this.paintCenterText },
			{ text: 'bounding box', value: this.paintBoundingBox },
		]

		const selected = options[1]

		return {
			reservedaysData: { business: { QRlogo: null } },
			qrReaderKey: 0,
			business: {},
			sweetInfo: {
				open: false,
				title: '',
				content: ``,
				modalIcon: 'info',
				cancelBtnText: '확인',
				buttonType: 'oneBtn',
			},
			selected,
			options,
			groupCodes: [],
			//카메라 방향
			camera: 'front',
			//카메라 유무 체크
			noRearCamera: false,
			noFrontCamera: false,
			// flash light
			torchActive: false,
			torchNotSupported: false,
			// 찍은 qr 정보
			result: null,
			// 인증완료 카드 model
			alertCard1: false,
			alertCard2: false,
			alertCard3: false,
			alertCard4: false,
			// 촬영 버튼
			btn: {
				block: true,
				dark: true,
				height: '7%',
				color: '#7DC269',
				class: 'qrCapture',
				icon: true,
				iconSize: '24px',
			},

			// info 다이어로그
			qrinfoDialog: { dialog: false, title: 'Test Business Name' },
			// 음성 재생 데이터
			voiceList: [],
			greetingSpeech: new window.SpeechSynthesisUtterance(),
			synth: window.speechSynthesis,
			/// user 이름
			userData: {},
			greetingUser: '',
			greetingUser2: '이미 인증되었습니다',
			greetingUser1: '예약일시를 확인하세요',
			greetingNum: '',
			windowWidth: window.innerWidth,
			windowHeight: window.innerHeight,
			groupdata: {},
			/// 상담자 reserve user 데이터
			reservedUser: {},

			// 오늘 대기 번호
			waitNum: '',
			messageData1: {},
			messageData2: {},
			messageData3: {},
			messageData4: {},
			messageData5: {},
			title: '', // (reservedays) 사업지명
			tplCode: '', // tplCode
			messageData: {}, // 알림톡 전송 정보
			originMsg: '',
			voiceSystemsList: {
				StartWork: { voice: '', version: 0 },
				LeaveWork: { voice: '', version: 0 },
				AlreadyStartWork: { voice: '', version: 0 },
				AlreadyLeaveWork: { voice: '', version: 0 },
			},
			ourCoords: {
				//서울 시청 좌표
				latitude: 37.5666263, //위도
				longitude: 126.9783924, //경도
			},
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.windowWidth = window.innerWidth
			})
			window.addEventListener('resize', () => {
				this.windowHeight = window.innerHeight
			})
			if (this.windowWidth <= 375) {
				return 'middleSquarexxxs'
			} else if (this.windowWidth <= 375) {
				return 'middleSquarexxs'
			} else if (this.windowWidth <= 425) {
				return 'middleSquarexs'
			} else if (this.windowWidth <= 768) {
				return 'middleSquaresm'
			} else if (this.windowWidth <= 1024) {
				return 'middleSquaremd'
			} else {
				return 'middleSquare'
			}
		},
		nowHeight() {
			window.addEventListener('resize', () => {
				this.windowHeight = window.innerHeight
			})
			return this.windowHeight
		},
	},
	async mounted() {
		await this.reservedays()
		await this.open_disable_dialog_first({
			title: '실행',
			content: '상담신청 QR Reader가 실행되었습니다.\nQR코드를 인식하여 상담신청을 진행해 주세요.',
		})
		await this.playSound('/tingtong.wav')
	},
	methods: {
		reservedays() {
			const data = {
				code: this.$route.params.code,
			}
			this.$store.dispatch('reservedays', data).then(res => {
				this.reservedaysData = res.data.reservedays[0]
				this.$store.state.reservedayData = res.data.reservedays[0]
			})
		},
		sendMessageForDirect(userdata) {
			const rdate = this.$moment(userdata.rdate)
				.subtract('hours', 9)
				.format('YYYY년 MM월 DD일 HH:mm')
			let url = `${location.protocol}//${location.hostname}/waitingCheck/${this.$route.params.code}/${userdata.phone}`
			// 청라 푸르지오 현장만 대기번호 자리에 사업지명(title)을 치환, 그 외 현장은 기존 동작(this.waitNum) 유지
			const waitNumValue =
				this.$store.state.reservedayData.title && this.$store.state.reservedayData.title.includes('청라 푸르지오')
					? this.$store.state.reservedayData.title + this.waitNum
					: this.waitNum
			if (this.messageData3.message === undefined) {
				// 생성 / 수정시 알림톡 tpl_code가 없는 경우
				return
			} else {
				try {
					const parsedMessage = JSON.parse(this.messageData3.message)
					if (typeof parsedMessage === 'object' && parsedMessage !== null) {
						const replacedMessage = {}
						for (const [key, value] of Object.entries(parsedMessage)) {
							let replacedValue = value
							// 모든 값에서 플레이스홀더를 실제 데이터로 교체
							replacedValue = replacedValue.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
							replacedValue = replacedValue.replace(/#{고객명}/g, userdata.name)
							replacedValue = replacedValue.replace(/#{상담신청일시}/g, rdate)
							replacedValue = replacedValue.replace(/#{상담 신청일시}/g, rdate)
							replacedValue = replacedValue.replace(/#{관람신청일시}/g, rdate)
							replacedValue = replacedValue.replace(/#{대기번호}/g, waitNumValue)
							replacedValue = replacedValue.replace(/#{대기번호1}/g, waitNumValue)
							replacedValue = replacedValue.replace(/#{대기번호2}/g, waitNumValue)
							replacedValue = replacedValue.replace(/#{대기자수}/g, this.waitLength)
							replacedValue = replacedValue.replace(/#{대기정보}/g, url)
							replacedValue = replacedValue.replace(/#{그룹}/g, this.$route.params.code)
							replacedValue = replacedValue.replace(/#{코드}/g, this.$route.params.code)
							replacedValue = replacedValue.replace(/#{전화번호}/g, userdata.phone)
							replacedValue = replacedValue.replace(/#{상담ID}/g, userdata.phone)
							replacedValue = replacedValue.replace(/#{방문ID}/g, userdata.phone)
							replacedMessage[key] = replacedValue
						}
						this.messageData3.message = JSON.stringify(replacedMessage)
					}
				} catch (error) {
					console.error('JSON 파싱 오류:', error)
					// 파싱 실패 시 기존 방식 사용
					this.messageData3.message = this.messageData3.message.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
					this.messageData3.message = this.messageData3.message.replace(/#{고객명}/g, userdata.name)
					this.messageData3.message = this.messageData3.message.replace(/#{상담신청일시}/g, rdate)
					this.messageData3.message = this.messageData3.message.replace(/#{상담 신청일시}/g, rdate)
					this.messageData3.message = this.messageData3.message.replace(/#{관람신청일시}/g, rdate)
					this.messageData3.message = this.messageData3.message.replace(/#{대기번호}/g, waitNumValue)
					this.messageData3.message = this.messageData3.message.replace(/#{대기번호1}/g, waitNumValue)
					this.messageData3.message = this.messageData3.message.replace(/#{대기번호2}/g, waitNumValue)
					this.messageData3.message = this.messageData3.message.replace(/#{대기자수}/g, this.waitLength)
					this.messageData3.message = this.messageData3.message.replace(/#{대기정보}/g, url)
					this.messageData3.message = this.messageData3.message.replace(/#{그룹}/g, this.$route.params.code)
					this.messageData3.message = this.messageData3.message.replace(/#{코드}/g, this.$route.params.code)
					this.messageData3.message = this.messageData3.message.replace(/#{전화번호}/g, userdata.phone)
				}
			}
			if (this.messageData3.button) {
				this.messageData3.button = this.messageData3.button.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
				this.messageData3.button = this.messageData3.button.replace(/#{고객명}/g, userdata.name)
				this.messageData3.button = this.messageData3.button.replace(/#{상담신청일시}/g, rdate)
				this.messageData3.button = this.messageData3.button.replace(/#{상담 신청일시}/g, rdate)
				this.messageData3.button = this.messageData3.button.replace(/#{관람신청일시}/g, rdate)
				this.messageData3.button = this.messageData3.button.replace(/#{대기번호}/g, waitNumValue)
				this.messageData3.button = this.messageData3.button.replace(/#{대기번호1}/g, waitNumValue)
				this.messageData3.button = this.messageData3.button.replace(/#{대기번호2}/g, waitNumValue)
				this.messageData3.button = this.messageData3.button.replace(/#{대기자수}/g, this.waitLength)
				this.messageData3.button = this.messageData3.button.replace(/#{대기정보}/g, url)
				this.messageData3.button = this.messageData3.button.replace(/#{그룹}/g, this.$route.params.code)
				this.messageData3.button = this.messageData3.button.replace(/#{코드}/g, this.$route.params.code)
				this.messageData3.button = this.messageData3.button.replace(/#{전화번호}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{그룹}/g, this.$route.params.code)
				this.messageData3.button = this.messageData3.button.replace(/#{그룹}/g, this.$route.params.code)
				this.messageData3.button = this.messageData3.button.replace(/#{코드}/g, this.$route.params.code)
				this.messageData3.button = this.messageData3.button.replace(/#{코드}/g, this.$route.params.code)
				this.messageData3.button = this.messageData3.button.replace(/#{전화번호}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{전화번호}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{상담ID}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{상담ID}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{방문ID}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{방문ID}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(
					/#{분양정보pdf}/g,
					this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
				)
				this.messageData3.button = this.messageData3.button.replace(
					/#{분양정보pdf}/g,
					this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
				)
				if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
					this.messageData3.button = this.messageData3.button.replace(
						/#{청약안내pdf}/g,
						this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
					)
					this.messageData3.button = this.messageData3.button.replace(
						/#{청약안내pdf}/g,
						this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
					)
				}
				this.messageData3.button = this.messageData3.button.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
				this.messageData3.button = this.messageData3.button.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
				this.messageData3.button = this.messageData3.button.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
				this.messageData3.button = this.messageData3.button.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
			}
			const data = {
				// 필수값

				code: this.$route.params.code,
				sender: this.messageData3.smssender,
				senderkey: this.messageData3.senderkey,
				tpl_code: this.messageData3.tplCode,
				receiver_1: userdata.phone,
				subject_1: this.messageData3.tplCodeStr,
				message_1: this.messageData3.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: userdata.name,
				failover: 'Y',
				fsubject_1: this.messageData3.tplCodeStr,
				fmessage_1: this.messageData3.button,
				pay: this.reservedaysData.business?.id,
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {
					this.open_disable_dialog({
						title: '상담신청 완료',
						content: '상담신청이 완료되었습니다.\n알림톡을 확인해주세요.',
					})
					this.pause()
					setTimeout(() => {
						this.unpause()
					}, 500)
					setTimeout(() => {
						this.sweetInfo.open = false
					}, 2000)
				})
				.catch(err => {
					console.log(err)
				})
		},
		createWaiting(data) {
			let filesId = []
			if (data.fileUpload.length > 0) {
				filesId = data.fileUpload
			}
			this.recentPhone = data.phone
			const datas = {
				inputBoxTitle: data.inputBoxTitle,
				tracking_code: data.tracking_code,
				name: data.name,
				phone: data.phone,

				code: this.$route.params.code
					? this.$route.params.code === '09buhz2luv'
						? '09buhz2luv1'
						: this.$route.params.code
					: process.env.VUE_APP_SAMPLE_CODE,
				ismarketing: data.ismarketing,
				ispersonal: 1,
				cdate: this.$moment(new Date()).add(9, 'hour'),
				date: data.date,
				bigCodes: data.bigCodes,
				checkbox: data.checkbox,
				checkone: data.checkone,
				etc: data.etc,
				textfiled: data.textfiled,
				// waitingnum: this.waitNum + 1,
				stat: 0,
				rdate: data.rdate,
				title: data.title,
				seat: 0, // 상담석으로 가기전의 대기 상태 부여 => seat = 0
				fileUpload: filesId,
				userData: data.userData,
				reserveType: data.reserveType,
				sex: data.sex,
				realname: data.realname,
				age: data.age,
				qualification: data.qualification,
				homeOwnership: data.homeOwnership,
				bankBook: data.bankBook,
				purpose: data.purpose,
				subscribe: data.subscribe,
				floor: data.floor,
				houseAcreage: data.houseAcreage,
				acreageUnit: data.acreageUnit,
				business: Number(this.reservedaysData.business.id),
				marketing: data.marketing,
				receiveInformation: this.$store.state.reserveUserData.receiveInformation,
			}
			this.$store
				.dispatch('createWaiting', datas)
				.then(resWaiting => {
					this.$store
						.dispatch('waitings', { id: resWaiting.data.createWaiting.waiting.id, code: resWaiting.data.createWaiting.waiting.code })
						.then(res => {
							this.waitNum = res.data.waitings[0].waitingnum
							this.$store
								.dispatch('waitingsConnection', {
									code: this.$route.params.code,
									// stat: 0,
									seat: 0,
									csdate: this.$moment().format('YYYY-MM-DD') + 'T00:00:00.000Z',
									cedate:
										this.$moment()
											.add(1, 'days')
											.format('YYYY-MM-DD') + 'T00:00:00.000Z',
									stat: 0,
								})
								.then(res => {
									const waitingsPeople = res.data.waitingsConnection.aggregate.count
									this.waitLength = waitingsPeople - 1
									this.$store.state.loading = false
									this.$store
										.dispatch('messages', {})
										.then(res => {
											// create / update 알림톡 tplCode messages 에서 찾기 -> reserveday tplCode 에서 index 0
											let foundIndex1 = res.data.messages.findIndex(obj => {
												return obj.tplCode === this.$store.state.reservedayData.tplCode[0]
											})
											// delete 알림톡 tplCode messages 에서 찾기 -> reserveday tplCode 에서 index 2
											let foundIndex2 = res.data.messages.findIndex(obj => {
												return obj.tplCode === this.$store.state.reservedayData.tplCode[2]
											})
											let foundIndex3 = res.data.messages.findIndex(obj => {
												return obj.tplCode === this.$store.state.reservedayData.tplCode[3]
											})
											let foundIndex4 = res.data.messages.findIndex(obj => {
												return obj.tplCode === this.$store.state.reservedayData.tplCode[12]
											})
											let foundIndex5 = res.data.messages.findIndex(obj => {
												return obj.tplCode === this.$store.state.reservedayData.tplCode[13]
											})
											if (foundIndex1 !== -1) {
												this.messageData1 = res.data.messages[foundIndex1] // create / update 알림톡 데이터
											}
											if (foundIndex2 !== -1) {
												this.messageData2 = res.data.messages[foundIndex2] // delete 알림톡 데이터
											}
											if (foundIndex3 !== -1) {
												this.messageData3 = res.data.messages[foundIndex3] // delete 알림톡 데이터
											}
											if (foundIndex4 !== -1) {
												this.messageData4 = res.data.messages[foundIndex4] // 내가 받을 알림톡 알림톡 데이터
											}
											if (foundIndex5 !== -1) {
												this.messageData5 = res.data.messages[foundIndex5] // 내가 받을 알림톡 알림톡 데이터
											}
											this.sendMessageForDirect(datas)
										})
										.catch(err => {
											console.log(err)
										})
								})
						})

					// this.$socket.emit('reservation', { code: datas.code })
					// this.$socket.emit('reservationBoardList', { code: datas.code })
				})
				.catch(() => {
					alert('일시적인오류가 발생하였습니다. 새로고침 후 다시 신청해 주세요.')
					this.$store.state.loading = false
				})
		},
		playSound(soundFile) {
			const audio = new Audio(soundFile)
			audio.volume = 1.0 // 볼륨 최대로 설정
			audio.load()

			// 사용자 상호작용 후 재생 (모바일 브라우저 정책)
			const playPromise = audio.play()

			if (playPromise !== undefined) {
				playPromise
					.then(() => {
						console.log('Audio played successfully')
					})
					.catch(error => {
						// 자동 재생 실패 시 - 사용자 클릭/터치 필요
						console.error('Audio play failed:', error)
						// 모바일에서는 사용자 제스처가 필요할 수 있음
						document.addEventListener(
							'click',
							() => {
								audio.play()
							},
							{ once: true },
						)
					})
			}
		},
		windowClose() {
			window.open('', '_self').close()
			this.$router.push({ name: 'dashBoard' })
		},

		open_disable_dialog_first(data, info) {
			// 불가 팝업 열기

			this.sweetInfo.title = data.title
			this.sweetInfo.content = data.content
			if (data.profile) this.sweetInfo.profile = data.profile
			if (!info) this.sweetInfo.modalIcon = `info`
			else this.sweetInfo.modalIcon = info
			this.sweetInfo.open = true
		},
		open_disable_dialog(data, info) {
			// 불가 팝업 열기

			this.sweetInfo.title = data.title
			this.sweetInfo.content = data.content
			if (data.profile) this.sweetInfo.profile = data.profile
			if (!info) this.sweetInfo.modalIcon = `info`
			else this.sweetInfo.modalIcon = info
			this.sweetInfo.open = true

			// 사운드 재생
			if (info === 'error') {
				this.playSound('/error.mp3')
			} else {
				this.playSound('/tingtong.wav')
			}
		},
		voice(voice) {
			this.greetingSpeech.text = `${voice}`
			// 한국어 목소리 선택
			let index = this.voiceList.findIndex(e => e.name === 'Google 한국의')
			this.greetingSpeech.voice = this.voiceList[index]

			this.synth.speak(this.greetingSpeech)
		},
		updateUser_NoAuth(users) {
			const data = {
				id: users.id,
				vacationsDays: users.vacationsDays + 1,
			}
			this.$store.dispatch('updateUser_NoAuth', data).then(() => {})
		},
		turnOffAlert() {
			setTimeout(() => {
				this.alertModal4.dialog = false
			}, 2000)
		},
		paintOutline(detectedCodes, ctx) {
			for (const detectedCode of detectedCodes) {
				const [firstPoint, ...otherPoints] = detectedCode.cornerPoints

				ctx.strokeStyle = 'yellow'

				ctx.beginPath()
				ctx.moveTo(firstPoint.x, firstPoint.y)
				for (const { x, y } of otherPoints) {
					ctx.lineTo(x, y)
				}
				ctx.lineTo(firstPoint.x, firstPoint.y)
				ctx.closePath()
				ctx.stroke()
			}
		},

		paintBoundingBox(detectedCodes, ctx) {
			for (const detectedCode of detectedCodes) {
				const {
					boundingBox: { x, y, width, height },
				} = detectedCode

				ctx.lineWidth = 2
				ctx.strokeStyle = '#007bff'
				ctx.strokeRect(x, y, width, height)
			}
		},

		paintCenterText(detectedCodes, ctx) {
			for (const detectedCode of detectedCodes) {
				const { boundingBox, rawValue } = detectedCode

				const centerX = boundingBox.x + boundingBox.width / 2
				const centerY = boundingBox.y + boundingBox.height / 2

				const fontSize = Math.max(12, (50 * boundingBox.width) / ctx.canvas.width)

				ctx.font = `bold ${fontSize}px sans-serif`
				ctx.textAlign = 'center'

				ctx.lineWidth = 3
				ctx.strokeStyle = '#35495e'
				ctx.strokeText(detectedCode.rawValue, centerX, centerY)

				ctx.fillStyle = '#5cb984'
				ctx.fillText(rawValue, centerX, centerY)
			}
		},

		switchCamera() {
			//카메라 변경
			switch (this.camera) {
				case 'front':
					this.camera = 'rear'
					break
				case 'rear':
					this.camera = 'front'
					break
				case 'auto':
					this.camera = 'front'
					break
			}
		},
		async logErrors(promise) {
			try {
				//카메라 변경
				await promise
			} catch (error) {
				const triedFrontCamera = this.camera === 'front'
				const triedRearCamera = this.camera === 'rear'

				const cameraMissingError = error.name === 'OverconstrainedError'

				if (triedRearCamera && cameraMissingError) {
					this.noRearCamera = true
				}

				if (triedFrontCamera && cameraMissingError) {
					this.noFrontCamera = true
				}

				console.error(error)
			}
			try {
				//플래시라이트 on off
				const { capabilities } = await promise

				this.torchNotSupported = !capabilities.torch
			} catch (error) {
				console.error(error)
			}
			try {
				//qr 읽기
				await promise
			} catch (e) {
				console.error(e)
			}
		},
		async QRUser(content) {
			if (content.indexOf('/') === -1) {
				this.open_disable_dialog(
					{
						title: '인증오류',
						content: `잘못된 QR코드입니다.\n다시 시도해 주세요.`,
					},
					'error',
				)
				this.pause()
				setTimeout(() => {
					this.unpause()
				}, 500)
				setTimeout(() => {
					this.sweetInfo.open = false
				}, 1000)
				return
			}
			if (content.split('/').length !== 2) {
				this.open_disable_dialog(
					{
						title: '인증오류',
						content: `잘못된 QR코드입니다.\n다시 시도해 주세요.`,
					},
					'error',
				)
				this.pause()
				setTimeout(() => {
					this.unpause()
				}, 500)
				setTimeout(() => {
					this.sweetInfo.open = false
				}, 1000)
				return
			}
			const data = {
				code: this.$route.params.code,
				phone: content.split('/')[0],
			}
			await this.$store.dispatch('reserveusers', data).then(res => {
				this.$store.state.loading = false
				if (res.data.reserveusers.length === 0) {
					this.open_disable_dialog(
						{
							title: '인증오류',
							content: `방문등록된 QR이 아닙니다.\n방문등록 후 이용해 주세요.`,
						},
						'error',
					)
					this.pause()
					setTimeout(() => {
						this.unpause()
					}, 500)
					setTimeout(() => {
						this.sweetInfo.open = false
					}, 1000)
					return
				}

				// 한국 시간 기준 오늘 날짜 (YYYY-MM-DD 형식)
				const today = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Seoul' }))
				const todayStr = today.toISOString().split('T')[0]

				// rdate가 오늘 날짜인 데이터만 필터링
				const todayReservation = res.data.reserveusers.find(item => {
					if (item && item.rdate) {
						const rdate = new Date(item.rdate).toISOString().split('T')[0]
						return rdate === todayStr
					}
					return false
				})
				if (todayReservation) {
					this.$store
						.dispatch('waitings', {
							code: this.$route.params.code,
							phone: todayReservation.phone,
							rsdate:
								this.$moment(new Date())
									.subtract(1, 'd')
									.format('YYYY-MM-DD') + 'T15:00:00.000Z',
						})
						.then(waiting => {
							// waiting.data.waitings 전체에서 오늘 날짜인 항목들을 모두 필터링
							const todayReservations = waiting.data.waitings

							// 오늘 날짜의 대기 중인 항목이 있는지 확인 (stat === 0 또는 stat === 1)
							const hasPendingReservation = todayReservations.some(item => item.stat === 0 || item.stat === 1)

							if (hasPendingReservation) {
								this.open_disable_dialog(
									{
										title: '상담QR중복',
										content: `[${todayReservation.name}님] 이미 상담대기 중 입니다.\n 상담이 완료된 후 다시 이용해 주세요.`,
									},
									'error',
								)
								this.pause()
								setTimeout(() => {
									this.unpause()
								}, 500)
								setTimeout(() => {
									this.sweetInfo.open = false
								}, 1000)
								return
							} else {
								this.createWaiting(todayReservation)
							}
						})
				} else {
					this.open_disable_dialog(
						{
							title: '인증오류',
							content: `[${res.data.reserveusers[0].name}님] 금일 등록된 QR이 아닙니다.\n방문등록 후 이용해 주세요.`,
						},
						'error',
					)

					this.pause()
					setTimeout(() => {
						this.unpause()
					}, 500)
					setTimeout(() => {
						this.sweetInfo.open = false
					}, 1000)
					return
				}
			})
		},
		async onDecode(content) {
			this.QRUser(content)
			setTimeout(() => {
				this.qrReaderKey++
			}, 1000)
		},
		unpause() {
			this.camera = 'front'
		},
		pause() {
			this.camera = 'off'
		},
		timeout(ms) {
			return new Promise(resolve => {
				window.setTimeout(resolve, ms)
			})
		},
	},
}
</script>

<style lang="scss">
.qrReader {
	height: 100vh !important;
}
/// 상단 메뉴 css
.qrHead {
	height: 9%;
	padding: 2vh 0px 0vw 2vw;
}
.qrHeadxs {
	height: 7%;
	padding: 2vh 0px 0vw 2vw;
}
// 상단 사업지명
.qrTitle {
	font-size: 4vh;
	font-weight: bold;
	color: white;
	border-radius: 10px;
	padding: 0.2vw 0px 0px 1vw;
}
.qrTitlexs {
	font-size: 3vh;
	font-weight: bold;
	color: white;
	border: 3px solid white;
	border-radius: 10px;
	padding: 0.2vw 0px 0px 1vw;
}
// 상단 버튼
.iconBtn {
	cursor: pointer;
	margin: 0px 5vw 0px 0px;
}
/// 인증완료 메세지 div
.confirmation {
	z-index: 1;
	position: inherit;
	width: 100%;
	text-align: -webkit-center;
	padding-top: 4vh;
}
/// 인증완료 메세지 카드
.alertCard1 {
	opacity: 0.7;
	width: 25vh;
	font-size: 2vh;
	padding: 10px;
	border-radius: 10px !important;
}
.alertCard2 {
	color: white !important;
	opacity: 0.7;
	width: 40vh;
	font-size: 2vh;
	padding: 10px;
	border-radius: 10px !important;
}
/// qr 인식 layout
.qrMiddle {
	z-index: 2;
	height: 84%;
}
.qrMiddlexs {
	z-index: 2;
	height: 86%;
}
// qr 인식 박스
.middleSquare {
	border: 4px dashed yellow;
	width: 30%;
	height: 69.5%;
}
.middleSquaremd {
	border: 4px dashed yellow;
	width: 48vw;
	height: 55vh;
}
.middleSquaresm {
	border: 4px dashed yellow;
	width: 58vw;
	height: 50vh;
}
.middleSquarexs {
	border: 4px dashed yellow;
	width: 63vw;
	height: 30vh;
}
.middleSquarexxs {
	border: 4px dashed yellow;
	width: 71vw;
	height: 30vh;
}
.middleSquarexxxs {
	border: 4px dashed yellow;
	width: 71vw;
	height: 25.5vh;
}
.hideBtn {
	display: none;
}
</style>
